<section class="ml-5">
  <article id="form-content">
    <form [formGroup]="addArticleForm" id="add-article-form" (ngSubmit)="submitForm()">
      <mat-card class="content">
        <h2>Ajouter un article</h2>
        <mat-form-field>
          <mat-label>Article</mat-label>
          <mat-select placeholder="Sélectionner un article" formControlName="article">
            <mat-option *ngFor="let article of articles" [value]="article">
              {{article.code_article}} - {{article.designation}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="addArticleForm.get('article').hasError('required')">Vous devez sélectionner un article</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-select placeholder="Change hebdomadaire" formControlName="change" [disabled]="!article.valid">
            <mat-option></mat-option>
            <mat-option *ngFor="let change of changes" [value]="change">
              {{change.qte_semaine}}/{{change.qte_prevue}} ({{change.type_facturation.cle_ref}})
            </mat-option>
          </mat-select>
          <mat-error *ngIf="addArticleForm.get('change').hasError('required')">Vous devez sélectionner un change</mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="facturationTypeSB()">
          <mat-label>Quantité souhaitée</mat-label>
          <mat-select [(value)]="selected_value" placeholder="Sélectionner une quantité" formControlName="qteSouhaite">
            <mat-option [value]=1>1</mat-option>
            <mat-option [value]=2>2</mat-option>
            <mat-option [value]=3>3</mat-option>
            <mat-option [value]=4>4</mat-option>
            <mat-option [value]=5>5</mat-option>
            <mat-option [value]=6>6</mat-option>
            <mat-option [value]=7>7</mat-option>
            <mat-option [value]=8>8</mat-option>
            <mat-option [value]=9>9</mat-option>
            <mat-option [value]=10>10</mat-option>
            <mat-option [value]=11>11</mat-option>
          </mat-select>
          <mat-error *ngIf="addArticleForm.get('qteSouhaite').hasError('required')">Vous devez sélectionner la
            quantité souhaitée</mat-error>
        </mat-form-field>
        <mat-form-field id="retouche"
          *ngIf="article.valid &&(article.value.code_article.charAt(0) == 3 || article.value.code_article.charAt(0) == 7)">
          <mat-select placeholder="Retouche du bas du vêtement en centimètre" formControlName="retouche" [disabled]="changes == undefined || !change.valid">
            <mat-option></mat-option>
            <mat-option *ngFor="let retouche of retouches" [value]="retouche">
              {{retouche}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="articleLoaded" class="flex items-center mb-5">
          <label>Taille : </label>
          <mat-icon (click)="dec()" class="icon-click">remove_circle_outline</mat-icon>
          <strong *ngIf="taille.value">{{taille.value.libelle_long}}</strong>
          <mat-icon (click)="inc()" class="icon-click">add_circle_outline</mat-icon>
        </div>
        <mat-form-field id="comment">
          <mat-label>Commentaire</mat-label>
          <textarea matInput placeholder="Saisir un commentaire" mdAutosizeMinRows formControlName="comment"></textarea>
        </mat-form-field>
        <p class="info-contact">Si l'article et/ou la règle de change hebdo ne sont pas disponibles, merci de <a
            routerLink="/contact-us">nous contacter</a>.</p>
        <mat-card-actions>
          <button mat-raised-button type="submit" [disabled]="!addArticleForm.valid">Enregistrer</button>
        </mat-card-actions>
      </mat-card>
    </form>
  </article>
  <article id="picto-content" *ngIf="articleLoaded">
    <img [src]="getSvg()" alt="picto" title="picto" />
    <div>
      <p><strong>{{ articleLoaded.code_article }}</strong></p>
      <p><strong>{{ articleLoaded.designation }}</strong></p>
    </div>
  </article>
</section>